export const DATE_PICKER_PORTAL_ID = 'date-picker-portal-id';
